/// <amd-module name="VSSUI/Components/IdentityCard/OrganizationCard" />
import * as React from "react";
import * as Resources from "VSSUI/Resources.Persona";

import { format } from "VSS/Core/Util/String";
import { Button } from "VSSUI/Button";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { IOrganizationCardProps } from "./ContactCard.Props";

export class OrganizationCard extends React.Component<IOrganizationCardProps> {
    // Render
    public render(): JSX.Element {
        const managerIdentityList = this.createManagerChainIdentityElements();
        const directReportIdentityList = this.createDirectReportsIdentityElements();

        return (
            <div className="bolt-identity-contact-card-organization-card-wrapper bolt-identity-card-content">
                <div className="bolt-identity-organization-card-content v-scroll-auto h-scroll-hidden">
                    <div className="bolt-identity-organization-card-header-wrapper">{Resources.IdentityCardOrganization} </div>
                    <div className="bolt-identity-organization-card-manager-chain-wrapper">{managerIdentityList}</div>
                    {directReportIdentityList.length > 0 && (
                        <div className="bolt-identity-organization-card-direct-reports-wrapper">
                            {format(
                                Resources.IdentityCardReportingTo,
                                this.props.identity.displayName,
                                this.props.directReportList ? this.props.directReportList.length : 0
                            )}
                            {directReportIdentityList}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // Helper methods to create Presona elements
    private createManagerChainIdentityElements = () => {
        const managerChainElementList = this.props.managerList
            ? this.props.managerList.map(manager => {
                  const managerData = {
                      imageUrl: manager.image,
                      primaryText: manager.displayName ? manager.displayName : "",
                      secondaryText: manager.jobTitle ? manager.jobTitle : "",
                      tertiaryText: manager.department ? manager.department : ""
                  };

                  return (
                      <div
                          className="bolt-identity-card-persona-list-row flex-row flex-grow scroll-hidden"
                          key={manager.entityId + manager.signInAddress}
                      >
                          <Button
                              aria-label={manager.displayName}
                              className="bolt-identity-card-persona-list-element profile-card-tab-element flex-row text-ellipsis"
                              onClick={() => {
                                  this.props.onClickEntity && this.props.onClickEntity(manager);
                              }}
                              subtle={true}
                          >
                              <Persona size={PersonaSize.size40} identity={manager} />
                              <div className="flex-column flex-grow bolt-identity-card-name text-ellipsis">
                                  <div className="text-left text-ellipsis">{managerData.primaryText}</div>
                                  {managerData.secondaryText === "" ? (
                                      undefined
                                  ) : (
                                      <div className="text-left text-ellipsis">{managerData.secondaryText}</div>
                                  )}
                              </div>
                          </Button>
                      </div>
                  );
              })
            : [];

        // Append current identity to list
        const mainIdentityData = {
            imageUrl: this.props.identity.image,
            primaryText: this.props.identity.displayName,
            secondaryText: this.props.identity.jobTitle,
            tertiaryText: this.props.identity.department
        };
        managerChainElementList.push(
            <div
                className="bolt-identity-card-persona-list-row flex-row flex-grow"
                key={this.props.identity.entityId + this.props.identity.signInAddress}
            >
                <Button
                    className="bolt-identity-card-persona-list-element profile-card-tab-element flex-row flex-shrink text-ellipsis"
                    aria-label={this.props.identity.displayName}
                    onClick={() => {
                        this.props.onClickEntity && this.props.onClickEntity(this.props.identity);
                    }}
                    subtle={true}
                >
                    <Persona size={PersonaSize.size40} identity={this.props.identity} />
                    <div className="flex-column flex-grow bolt-identity-card-name text-ellipsis">
                        <div className="text-left text-ellipsis">{mainIdentityData.primaryText}</div>
                        {mainIdentityData.secondaryText === "" ? (
                            undefined
                        ) : (
                            <div className="text-left text-ellipsis">{mainIdentityData.secondaryText}</div>
                        )}
                    </div>
                </Button>
            </div>
        );

        return managerChainElementList;
    };

    private createDirectReportsIdentityElements = () => {
        const directReportElementList = this.props.directReportList
            ? this.props.directReportList.map(directReport => {
                  const directReportData = {
                      imageUrl: directReport.image,
                      primaryText: directReport.displayName ? directReport.displayName : "",
                      secondaryText: directReport.jobTitle ? directReport.jobTitle : "",
                      tertiaryText: directReport.department ? directReport.department : ""
                  };

                  return (
                      <div
                          className="bolt-identity-card-persona-list-row flex-row flex-grow"
                          key={directReport.entityId + directReport.signInAddress}
                      >
                          <Button
                              className="bolt-identity-card-persona-list-element profile-card-tab-element flex-row text-ellipsis"
                              aria-label={directReport.displayName}
                              onClick={() => {
                                  this.props.onClickEntity && this.props.onClickEntity(directReport);
                              }}
                              subtle={true}
                          >
                              <Persona size={PersonaSize.size40} identity={directReport} />
                              <div className="flex-column flex-grow bolt-identity-card-name text-ellipsis">
                                  <div className="text-left text-ellipsis">{directReportData.primaryText}</div>
                                  {directReportData.secondaryText === "" ? (
                                      undefined
                                  ) : (
                                      <div className="text-left text-ellipsis">{directReportData.secondaryText}</div>
                                  )}
                              </div>
                          </Button>
                      </div>
                  );
              })
            : [];

        return directReportElementList;
    };
}
